import type { AppDispatch } from "@/store/app/storeTypes";
import {
  backgroundIndexFinished,
  backgroundIndexStarted,
} from "@/store/sparxsCatalog/searchIndexSlice";

export type SearchIndexRunHandle = {
  start: (payload: { totalFiles: number; clearRows?: boolean }) => void;

  finishIfCurrent: () => void;

  releaseIndexingUi: () => void;
};

export const releaseSearchIndexingUi = (dispatch: AppDispatch) => {
  dispatch(backgroundIndexFinished());
};

export const createSearchIndexRunHandle = (params: {
  dispatch: AppDispatch;
  runId: number;
  getCurrentRunId: () => number;
}): SearchIndexRunHandle => {
  const { dispatch, runId, getCurrentRunId } = params;

  return {
    start: (payload) => {
      dispatch(backgroundIndexStarted(payload));
    },
    finishIfCurrent: () => {
      if (runId === getCurrentRunId()) {
        dispatch(backgroundIndexFinished());
      }
    },
    releaseIndexingUi: () => {
      releaseSearchIndexingUi(dispatch);
    },
  };
};
